import type {Recipe} from './types';

export const paniniNapoletani: Recipe = {
    id: 5,
    key: "paniniNapoletani",
    pictures: [
        {index: 0, url: "https://www.misya.info/wp-content/uploads/2007/10/Panini-napoletani2.jpg"},
    ],
    i18n: {
        IT: {
            title: "Panini Napoletani",
            servings: "10 panini",
            ingredients: [
                "400 gr di farina 00",
                "100 ml di acqua",
                "100 ml di latte",
                "5 gr di lievito di birra",
                "70 gr di strutto",
                "1 cucchiaino di sale",
                "20 gr di grana",
                "100 gr di pancetta",
                "70 gr di prosciutto cotto",
                "150 gr di provolone",
                "2 uova sode opzionali",
            ],
            steps: [
                "Far sciogliere il lievito nel latte e l'acqua appena tiepidi.",
                "In un'ampia ciotola, disporre la farina, fare un buco al centro ed iniziare a versare man mano l'acqua, il latte e il lievito.",
                "Quando la pasta inizia ad addensarsi, aggiungere sale, e 2 cucchiai di sugna, e continuare a lavorare fino ad avere un panetto liscio ed elastico.",
                "Lasciar riposare il panetto 2 ore al coperto.",
                "Riprendere il panetto e stenderlo con le mani fino a formare una sfoglia rettangolare di 3 mm circa.",
                "Ricoprire con prosciutto cotto, pancetta e provolone piccante a pezzetti, e due uova sode sbriciolate, se vi piacciono. Poi pigiare con le mani affinché i pezzetti penetrino parzialmente nell'impasto e poi cospargere con del grana grattugiato.",
                "Avvolgere la sfoglia formando un rotolo non troppo stretto e tagliarlo a tranci di circa 3 dita di larghezza.",
                "Adagiare i panini napoletani su una teglia unta di olio e lasciarli lievitare coperti da un telo per 2 ore.",
                "Una volta lievitati, spennellare i panini napoletani con il cucchiaio di strutto rimanente e far riposare anciora per 30 minuti. Cuocete in forno preriscaldato a 180°C per 20 minuti circa.",
                "Lasciar intiepidire prima di servirli.",
            ],
            notes: "Per panini più leggeri, puoi utilizzare l'olio di oliva al posto dello strutto, impiegando due cucchiai colmi per l'impasto e altro olio d'oliva per la spennellatura prima di metterli in forno.",
        },
        EN: {
            title: "Neapolitan Sandwiches",
            servings: "10 sandwiches",
            ingredients: [
                "400 grams of all-purpose flour",
                "100 ml of water",
                "100 ml of milk",
                "5 grams of fresh yeast",
                "70 grams of lard",
                "1 teaspoon of salt",
                "20 grams of Parmesan cheese",
                "100 grams of pancetta",
                "70 grams of cooked ham",
                "150 grams of provolone cheese",
                "2 hard-boiled eggs (optional)",
            ],
            steps: [
                "Dissolve the yeast in the lukewarm milk and water.",
                "In a large bowl, place the flour, make a well in the center, and gradually pour in the water, milk, and yeast.",
                "When the dough starts to thicken, add salt and 2 tablespoons of lard, and continue to work it until you get a smooth and elastic dough.",
                "Let the dough rest for 2 hours covered.",
                "Take the dough and spread it with your hands to form a rectangular sheet about 3 mm thick.",
                "Cover with cooked ham, pancetta, spicy provolone cheese pieces, and two crumbled hard-boiled eggs if you like. Then press with your hands so that the pieces partially penetrate the dough and sprinkle with grated Parmesan.",
                "Roll the sheet forming a not too tight roll and cut it into slices about 3 fingers wide.",
                "Place the Neapolitan sandwiches on an oiled baking sheet and let them rise covered with a cloth for 2 hours.",
                "Once risen, brush the Neapolitan sandwiches with the remaining tablespoon of lard and let them rest for another 30 minutes. Bake in a preheated oven at 180°C (356°F) for about 20 minutes.",
                "Let them cool slightly before serving.",
            ],
            notes: "For lighter sandwiches, you can use olive oil instead of lard, using two heaping tablespoons for the dough and additional olive oil for brushing before baking.",
        },
        PL: {
            title: "Kanapki Neapolitańskie",
            servings: "10 kanapek",
            ingredients: [
                "400 gramów mąki uniwersalnej",
                "100 ml wody",
                "100 ml mleka",
                "5 gramów świeżych drożdży",
                "70 gramów smalcu",
                "1 łyżeczka soli",
                "20 gramów parmezanu",
                "100 gramów pancetty",
                "70 gramów gotowanej szynki",
                "150 gramów sera provolone",
                "2 jajka na twardo (opcjonalnie)",
                "Rozpuść drożdże w letnim mleku i wodzie.",
            ],
            steps: [
                "W dużej misce umieść mąkę, zrób wgłębienie w środku i stopniowo wlewaj wodę, mleko i drożdże.",
                "Gdy ciasto zacznie gęstnieć, dodaj sól i 2 łyżki smalcu, i kontynuuj wyrabianie, aż uzyskasz gładkie i elastyczne ciasto.",
                "Pozostaw ciasto na 2 godziny pod przykryciem.",
                "Weź ciasto i rozwałkuj rękoma, aby uformować prostokątny arkusz o grubości około 3 mm.",
                "Pokryj gotowaną szynką, pancettą, kawałkami ostrego sera provolone i dwoma pokruszonymi jajkami na twardo, jeśli lubisz. Następnie dociśnij rękami, aby kawałki częściowo wniknęły w ciasto i posyp startym parmezanem.",
                "Zwiń arkusz, formując niezbyt ciasny rulon, i pokrój go na plastry szerokości około 3 palców.",
                "Umieść neapolitańskie kanapki na natłuszczonej olejem blasze do pieczenia i pozostaw do wyrośnięcia przykryte ściereczką na 2 godziny.",
                "Po wyrośnięciu, posmaruj neapolitańskie kanapki pozostałą łyżką smalcu i pozostaw na kolejne 30 minut. Piecz w nagrzanym piekarniku w temperaturze 180°C przez około 20 minut.",
                "Pozostaw do lekkiego ostygnięcia przed podaniem.",
            ],
            notes: "Aby uzyskać lżejsze kanapki, możesz użyć oliwy z oliwek zamiast smalcu, używając dwóch kopiastych łyżek do ciasta i dodatkowej oliwy z oliwek do smarowania przed pieczeniem.",
        },
    },
};
